export const ListQueryKey = 'signConfigs';
export const DetailQueryKey = 'signConfig';

export const Urls = {
  selectUrl: '/signConfig/list',
  updateUrl: '/signConfig/update',
  deleteUrl: '/signConfig/delete',
  createUrl: '/signConfig/create',
  detailUrl: '/signConfig/detail',
};
